// extracted by mini-css-extract-plugin
export default {"LogoImage":"PyltCA1D","HeaderWrapper":"ZBFbxGly","HeaderContent":"bzzQkx9I","noSpacing":"dfh_rgKC"};